// libs
import React from 'react';
import cx from 'classnames';
// dls
import DlsTextField from '@/widgets/DlsTextFeild';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// defs
import { RightActionTypes, TextFieldTypes, } from '@swiggy-private/dls-web-core/dist/components/TextField/types';
import { IKeywordValidationType, } from '@/stores/WriteCampaign/defs';
// widgets
import { InfoFooter } from '@/widgets/InfoFooter';
// helpers
import { formatNumberIntl, prefixWithRupee } from '@/helpers/utils';
// constants
import { IconSuggestion, IconWarning } from '@/constants/icons/svg';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// styles
import styles from './BidInputField.module.scss';
const LABEL = 'Enter your bid';
const WARNING_ICON_FILL_COLOR = '#D07D00';
const errorClassMap = {
    [IKeywordValidationType.INVALID]: styles.footerError,
    [IKeywordValidationType.ZERO_BID_RANGE]: styles.footerZeroBidRangeError,
};
const BidInputField = (props) => {
    const { value, onChange, minValue, errorMessage, suggestedLowerBid, suggestedUpperBid, } = props;
    const zeroBidRange = suggestedLowerBid === 0 && suggestedUpperBid === 0;
    const handleChange = (value) => {
        onChange(value);
    };
    const renderSuggestedKeywordRange = () => {
        const dlsTextVariant = zeroBidRange
            ? DlsFontVariants.captionText
            : DlsFontVariants.body_B3_Med;
        const dlsTextColor = zeroBidRange
            ? DlsColorTokens.text_Highest_Emphasis
            : DlsColorTokens.negative;
        if (errorMessage) {
            return (React.createElement(React.Fragment, null,
                zeroBidRange && (React.createElement(IconWarning, { fillColor: WARNING_ICON_FILL_COLOR })),
                React.createElement(Text, { variant: dlsTextVariant, color: dlsTextColor }, errorMessage.message)));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(IconSuggestion, { fillColor: "#02060C", opacity: "0.92" }),
            React.createElement(Text, { variant: DlsFontVariants.captionText, color: DlsColorTokens.text_Highest_Emphasis }, props.suggestedLowerBid !== props.suggestedUpperBid ? (React.createElement(React.Fragment, null,
                "Suggested Bid Range",
                ' ',
                React.createElement("b", null,
                    prefixWithRupee(formatNumberIntl({
                        value: props.suggestedLowerBid,
                    })),
                    ' ',
                    "to",
                    ' ',
                    prefixWithRupee(formatNumberIntl({
                        value: props.suggestedUpperBid,
                    }))))) : (React.createElement(React.Fragment, null,
                "Suggested Bid Around",
                ' ',
                React.createElement("b", null, prefixWithRupee(formatNumberIntl({
                    value: props.suggestedLowerBid,
                }))))))));
    };
    const shouldShowInfoFooter = !!(errorMessage ||
        (props.suggestedLowerBid && props.suggestedLowerBid > 0) ||
        (props.suggestedUpperBid && props.suggestedUpperBid > 0));
    return (React.createElement(InfoFooter, { showInfo: shouldShowInfoFooter, footerClassName: cx(styles.footer, !!errorMessage && errorClassMap[errorMessage.type]), renderInfo: renderSuggestedKeywordRange },
        React.createElement(DlsTextField, { textFieldDetails: {
                value: value,
                type: TextFieldTypes.NUMBER,
                name: 'user-bid-input',
                label: LABEL,
                onChange: handleChange,
                isDisabled: false,
            }, rightActionDetails: [
                {
                    type: RightActionTypes.CLEAR,
                },
            ] })));
};
export default BidInputField;
